import enLang from './entries/en-US';
import ruLang from './entries/ru_RU';
import zhLang from './entries/zh-Hans-CN';
import arLang from './entries/ar_SA';
import itLang from './entries/it_IT';
import esLang from './entries/es_ES';
import frLang from './entries/fr_FR';
import {addLocaleData} from 'react-intl';
import srLang from './entries/sr_RS';

const AppLocale = {
  en: enLang,
  ru: ruLang,
  sr: srLang
  // zh: zhLang,
  // ar: arLang,
  // it: itLang,
  // es: esLang,
  // fr: frLang
};
addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.ru.data);
addLocaleData(AppLocale.sr.data);
// addLocaleData(AppLocale.zh.data);
// addLocaleData(AppLocale.ar.data);
// addLocaleData(AppLocale.it.data);
// addLocaleData(AppLocale.es.data);
// addLocaleData(AppLocale.fr.data);

export default AppLocale;
